module.exports = __webpack_public_path__ + "static/Underdown5-5e3105d78a3f229f774d71f7be07db4b.webp";